$(function () {
    $(".faq-question").on("click", function (e) {
        if (e.currentTarget.classList.contains("faq-question")) {
            $(this).toggleClass("active");
            let question_id = $(this).attr("id");
            let uuid = question_id.replace("faq-q", "");
            let answer_id = "faq-a" + uuid;
            $("#" + answer_id).collapse("toggle");
        }
    });

    if (location.pathname.includes("faq")) {
        let faq_id = location.hash.slice(1);
        if (faq_id) {
            let faq_el = $("#" + faq_id);
            if (faq_el.hasClass("faq-question")) {
                faq_el.trigger("click");
            }
        }
    }

    $(".sticky-container a").click(function(e) {
        if ($(this).text().trim().toLowerCase() !== "contact") {
            e.preventDefault();
            let target_id = $(this).attr("href").replace("#", "");
            let target_el = $("#" + target_id);
            let offset = target_el.offset().top - 75;
            window.scrollTo({
                top: offset,
                behavior: "smooth"
            });
        }
    });

    $(".sticky-container").scrollLeft(1);
    $(".sticky-container").scrollLeft(0);
    
    $(".sticky-container").scroll(function() {
        var $width = $(this).outerWidth()
        var $scrollWidth = $(this)[0].scrollWidth; 
        var $scrollLeft = $(this).scrollLeft();

        if (Math.round($scrollWidth - $width) === Math.round($scrollLeft)) {
            $(this).removeClass("show-right");
        } else {
            $(this).addClass("show-right");
        }

        if ($scrollLeft === 0) {
            $(this).removeClass("show-left");
        } else {
            $(this).addClass("show-left");
        }
    });
});
